import {inject} from '@angular/core';
import {TranslateService as RuntimeTranslateService} from '@ngx-translate/core';
import {Component, OnInit} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {NgxSpinnerService} from 'ngx-spinner';
import Swal from 'sweetalert2';
import {SiteService} from '../../../services/site.service';
import {ConfigService} from '../../../services/config.service';
import { OrderPipe } from 'ngx-order-pipe';
import {ExportToCsv} from 'export-to-csv';
import {LoginService} from '../../../services/login.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-client',
    templateUrl: './client.component.html',
    styleUrls: ['./client.component.css'],
    standalone: false
})
export class ClientComponent implements OnInit {
  private readonly runtimeTranslate = inject(RuntimeTranslateService);
  // tslint:disable-next-line:max-line-length
  constructor(private loginService: LoginService,  private router: Router, private orderPipe: OrderPipe, private userService: UserService, private spinner: NgxSpinnerService, private siteService: SiteService, private configService: ConfigService) {
    this.sortedCollection = orderPipe.transform(this.users, 'verifications.name');
  }
  page = 1;

  public showLoaderExport: boolean;
  order = 'verifications.name';
  reverse = false;
  dateOrder: string = '';
  dateReverse = false;
  sortedCollection: any[];
  public pageList = [];
  public user_sites_label: any;
  public profile_id = parseInt(localStorage.getItem('profile_id'));
  public site_connected_id = parseInt(localStorage.getItem('site_id'));
  public user_conntected = JSON.parse(localStorage.getItem('currentUser'));
  public admin_login = this.user_conntected.login;
  public users: any[];
  public Allusers: any;
  public user_sites: any;
  public userToExport: any[];
  public count_client: any;
  show = 10;
  number_page: any;
  vQuery: string;
  addingSuccess: boolean;
  site_id: any;
  sites: any;
  showLoadConnection: boolean;
  showLoadList: boolean;
  showLoader = true;
  showLabel = true;
  displayBody =  true;
  public entityType = this.configService.entityType;

  ngOnInit() {
    this.configService.checkUSerAccessByProfile(this.profile_id);
    this.get_list_clients();
    this.get_list_sites();
  }

  // La méthode de filtrage qui combine le nom et prénom
  getFilteredUsers() {
    if (!this.vQuery || this.vQuery.trim() === '') {
      return this.users;  // Retourne tous les utilisateurs si aucun texte n'est saisi
    }

    const searchTerms = this.vQuery.toLowerCase().split(' ').filter(term => term.trim() !== '');

    return this.users.filter(user => {
      const name = user.user.name ? user.user.name.toLowerCase() : '';
      const firstname = user.user.firstname ? user.user.firstname.toLowerCase() : '';

      // Vérifie si tous les termes de recherche se trouvent dans le nom ou le prénom
      return searchTerms.every(term => name.includes(term) || firstname.includes(term));
    });
  }


  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    } else {
      this.reverse = false;
    }

    this.order = value;
    this.dateOrder = ''; // Réinitialiser le tri par date


    // Appliquer le tri après le filtrage et la normalisation
    this.users.sort((a, b) => {
      const fieldA = a.user && a.user[value] ? a.user[value].normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "").toLowerCase(): '';

      const fieldB = b.user && b.user[value]? b.user[value].normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "").toLowerCase(): '';

      // Comparer les deux champs pour déterminer l'ordre de tri
      return this.reverse
        ? fieldB.localeCompare(fieldA)
        : fieldA.localeCompare(fieldB);
    });
  }

   // Méthode pour le tri des dates
  setDateOrder(value: string) {
    if (this.dateOrder === value) {
      this.dateReverse = !this.dateReverse;
    } else {
      this.dateReverse = false;
    }
    this.dateOrder = value;
    this.order = ''; // Réinitialiser le tri par nom/prénom


    // Tri par dates
    this.users.sort((a, b) => {
      const dateA = this.convertToDate(a.user[value.split('.')[1]]);
      const dateB = this.convertToDate(b.user[value.split('.')[1]]);
      if (dateA && dateB) {
        return this.dateReverse
          ? dateB.getTime() - dateA.getTime()
          : dateA.getTime() - dateB.getTime();
      }
      if (!dateA && dateB) return this.dateReverse ? -1 : 1;
      if (dateA && !dateB) return this.dateReverse ? 1 : -1;
      return 0;
    });
  }
  get_list_sites() {
    this.siteService.getSite()
      .subscribe(res => {
        this.sites = res.data;
      }, (err) => {
        console.log(err);
      });
  }

  get_client_sites(id_site, profile) {
    this.spinner.show();
    this.siteService.get_site_client(id_site, profile)
      .subscribe(res => {
        this.count_client = res.data.length;
        this.users = res.data;
        this.Allusers = [ ...this.users ];
        this.spinner.hide();
      }, (err) => {
        console.log(err);
      });
  }

  get_user_sites(id_user) {
    this.showLoader = true;
    this.userService.get_user_site_list(id_user)
      .subscribe(res => {
        // @ts-ignore
        this.user_sites_label = res.data;
        this.showLoader = false;
      }, (err) => {
        console.log(err);
      });
  }

  get_list_clients() {
    this.spinner.show();
    this.userService.getListClient()
      .subscribe(res => {
        // @ts-ignore
        this.count_client = res.data.length;
        // @ts-ignore
        this.users = res.data.map(user => {
          // Tri sur les noms et prénoms pour un affichage uniforme pour les espaces et les Majuscules
          return {
            ...user,
            user: {
              ...user.user,
              name: user.user.name ? user.user.name.replace(/\s+/g, "").toUpperCase() : '', // Convertir en majuscules
              firstname: user.user.firstname ? user.user.firstname.replace(/\s+/g, "").toUpperCase() : '', // Convertir en majuscules
            }
          };
        });
        this.Allusers = [...this.users];

        // Appliquer un tri initial pour s'assurer que la liste est ordonnée
        this.setOrder('name');
        this.spinner.hide();
      }, (err) => {
        console.log(err);
        this.spinner.hide();
      });
  }

  increaseShow() {
    this.spinner.show();
    this.show += 10;
    this.get_list_clients();
    this.spinner.hide();
  }

  delete_client(id_client: any) {
    Swal.fire({
      title: this.runtimeTranslate.instant('alerts.confirmDelete'),
      text: this.runtimeTranslate.instant('alerts.irreversible'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.runtimeTranslate.instant('alerts.yesDelete'),
      cancelButtonText: this.runtimeTranslate.instant('common.cancel')
    }).then((result) => {
      if (result.value) {
        // @ts-ignore
        this.userService.deleteClient(id_client)
          .subscribe(res => {
            this.addingSuccess = true;
            this.get_list_clients();
          }, (err) => {
            console.log(err);
          });
        Swal.fire(
          this.runtimeTranslate.instant('alerts.deleted'),
          this.runtimeTranslate.instant('alerts.clientDeleted'),
          'success'
        );
      }
    });
  }


  filterSite(value) {
    if (value === 'Tout') {
      // Si "Tout" est sélectionné, chargez tous les adminstrateurs de site
      this.get_list_clients() ;
    } else {
      // Si un site spécifique est sélectionné, chargez les adminstrateurs de site pour ce site
      this.get_client_sites(value, this.profile_id);
    }
  }

  get_user_sites_for_export(id_user) {
    this.userService.get_user_site_list(id_user)
      .subscribe(res => {
        return res;

      }, (err) => {
        console.log(err);
      });
  }

  exporter() {
    this.showLoaderExport = true;
    this.spinner.show();

    this.userService.getClient_export().subscribe(
      (res: any) => {
        this.spinner.hide();
        this.userToExport = res?.data || [];

        const dataToExport = [];
        const options = {
          fieldSeparator: ';',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title: this.runtimeTranslate.instant('alerts.exportSiteAdministrators'),
          filename: 'liste_administrateurs_site_' + this.formatDate(),
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: false,
          headers: [this.runtimeTranslate.instant('exportHeaders.lastName'), this.runtimeTranslate.instant('exportHeaders.firstName'), this.runtimeTranslate.instant('exportHeaders.sites'), this.runtimeTranslate.instant('exportHeaders.startDate'), this.runtimeTranslate.instant('exportHeaders.endDate'), this.runtimeTranslate.instant('exportHeaders.status')]
        };

        console.log('[EXPORT] Utilisateurs à exporter (admin site) :', this.userToExport);

        this.userToExport.forEach((rdata, index) => {
          try {
            const user = rdata?.user || {};
            const siteNames = Array.isArray(rdata?.sites)
              ? rdata.sites.map(site => site?.name || '').join(' -- ')
              : '';

            const data = {
              'Noms': user.name || '',
              'Prénoms': user.firstname || '',
              'Sites': siteNames,
              'Date de début': user.start_date && user.start_date !== '01/01/1970' ? user.start_date : '',
              'Date de fin': user.end_date && user.end_date !== '01/01/1970' ? user.end_date : '',
              'Statut': user.hasOwnProperty('active') ? (user.active === 1 ? 'Actif' : 'Non actif') : 'Inconnu'
            };

            console.log(`[EXPORT L${index}] Données ligne :`, data);
            dataToExport.push(data);
          } catch (e) {
            console.error(`[EXPORT L${index}] Erreur lors du traitement :`, rdata, e);
          }
        });

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(dataToExport);
        this.showLoaderExport = false;
      },
      (err) => {
        console.error('Erreur export administrateurs site :', err);
        this.spinner.hide();
        this.showLoaderExport = false;
      }
    );
  }



  formatDate() {
    // tslint:disable-next-line:one-variable-per-declaration
    const d = new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    const hour = d.getHours();
    const minute = d.getMinutes();
    const seconde = d.getSeconds();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    const dateJoin = [year, month, day].join('');
    const hourJOin = [hour, minute, seconde].join('');
    return [dateJoin, hourJOin].join('_');
  }
  // tslint:disable-next-line:variable-name

  // tslint:disable-next-line:variable-name
  prise_en_main(login_t, email_t) {
    this.showLoadConnection = true;
    this.spinner.show();
    const body = {
      login: login_t,
      email: email_t
    };
    // @ts-ignore
    this.userService.take_in_hand(body)
      .subscribe(res => {
        this.loginService.logout_take_in_hand();
        // @ts-ignore
        if (res.status === 'success') {
          // @ts-ignore
          localStorage.setItem('currentUser', JSON.stringify(res.user));
          localStorage.setItem('takeInHand', 'yes');
          localStorage.setItem('admin_login', this.admin_login);
          // @ts-ignore
          localStorage.setItem('tokenCurrentConnected', JSON.stringify(res.token));
          // @ts-ignore
          this.loginService.currentUserSubject.next(res.user);
          // @ts-ignore
          localStorage.setItem('profile_id', res.profile_id);
          // @ts-ignore
          localStorage.setItem('site_id', res.site_id);
          // @ts-ignore
          if (res.profile_id === 10) {
            window.location.reload();
            this.router.navigate(['dashboard/inspector']);
            return false;
          }
          window.location.reload();
          this.router.navigate(['dashboard/administrator']);
          return false;
        }
        this.spinner.hide();
      }, (err) => {
        console.log(err);
      });
  }

  handlePageChange(event) {
    this.page = event;
  }

  get_count_client() {
    this.userService.getCountClient()
      .subscribe(res => {
        // @ts-ignore
        this.number_page = res.page_total;

        for (let i = 1; i <= this.number_page; i++) {
          const page = {
            page: 'Page ' + i,
            id:  i,
          };
          this.pageList.push(page);
        }
      }, (err) => {
        console.log(err);
      });
  }

  // tslint:disable-next-line:variable-name
  listingSiteUser(user_id, profile_id) {
    this.displayBody = false;
    this.showLoader = true;
    this.showLabel = false;
    this.userService.getUserSiteAnd_Profil_InFront(user_id, profile_id)
      .subscribe(res => {
        this.displayBody = true;
        this.showLabel = true;
        // @ts-ignore
        this.user_sites = res.sites;
        this.showLoader = false;
      }, (err) => {
        console.log(err);
      });
  }

  convertToDate(dateString: string | null | undefined): Date | null {
    // Vérifiez si dateString est défini et non vide
    if (!dateString || dateString.trim() === '') {
        return null;
    }

    // Séparez les parties du jour, du mois et de l'année
    const [day, month, year] = dateString.split('/').map(Number);

    // Vérification des valeurs
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
        return null;
    }

    // Créez un objet Date
    const date = new Date(year, month - 1, day);

    // Vérification si la date est valide
    if (!isNaN(date.getTime())) {
        return date;
    }

    return null;
  }


}
